<script>
import Vue from "vue"
import {ACTIVE_TYPE} from "../core/reserved-const"

export const state = Vue.observable({
  type: ACTIVE_TYPE.ALL
})

const getters = Vue.observable({
  allActive() {
    if(state.type === ACTIVE_TYPE.ALL) return true
    return false
  },
  topActive() {
    if(state.type === ACTIVE_TYPE.ALL) return true
    if(state.type === ACTIVE_TYPE.TOP) return true
    return false
  },
  mijnActive() {
    if(state.type === ACTIVE_TYPE.ALL) return true
    if(state.type === ACTIVE_TYPE.MIJN) return true
    return false
  }
})

export default {
  render() {
    return this.$scopedSlots.default({
      type: this.type,
      update: this.update
    })
  },

  data: () => ({
    type: state.type
  }),

  methods: {
    update(val) {
      state.type = val
    },

    async setQuery() {
      this.$router.replace()
      this.$emit('changed')
    }
  },

  provide: function() {
    return {
      type: state.type,
      topActive: getters.topActive,
      mijnActive: getters.mijnActive,
      allActive: getters.allActive
    }
  }
}
</script>